import React, { use, useState } from 'react';
import HttpManager from '../utils/HttpManager';
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';

const ContactForm = () => {
    const navigate = useNavigate();

    const [Name, setName] = useState('');
    const [Email, setEmail] = useState('');
    const [Subject, setSubject] = useState('');
    const [Message, setMessage] = useState('');

    const [errors, setErrors] = useState({});
    const [submitted, setSubmitted] = useState(false);
    const [loading, setLoading] = useState(false);

    const validate = () => {
        const newErrors = {};
        if (!Name.trim()) newErrors.name = 'Name is required';
        if (!Email.trim()) {
            newErrors.email = 'Email is required';
        } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(Email)) {
            newErrors.email = 'Invalid email format';
        }
        if (!Subject.trim()) newErrors.subject = 'Subject is required';
        if (!Message.trim()) {
            newErrors.message = 'Message is required';
        } else if (Message.length > 1500) {
            newErrors.message = 'Message must be 1500 characters or less';
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!validate()) return;

        setLoading(true);
        try {
            const form = {
                Name,
                Email,
                Subject,
                Message
            }
            const responseData = await new HttpManager(navigate).post('/Contact/ContactUs', form, true);

            console.log(responseData);
            setSubmitted(true);
        } catch (err) {
            console.error('Error sending message:', err);
            alert('Failed to send message. Please try again later.');
            Swal.fire({
                title: "Error",
                text: "Failed to send message. Please try again later or wriet us at SalesNSupport@decipherX.in",
                icon: "error"
            });
        }
        finally {
            setLoading(false);
        }
    };

    if (submitted) {
        return (
            <div className="text-center p-4 border rounded bg-light">
                <h2 className="text-success mb-3">Message Sent Successfully!</h2>
                <p>Thank you for reaching out to us. Our team will get back to you within <strong>24–48 hours</strong>.</p>
            </div>
        );
    }

    return (
        <div className="col-md-7">
            <form onSubmit={handleSubmit} noValidate>
                <div className="mb-3">
                    <label htmlFor="Name" className="form-label">Your Name</label>
                    <input type="text" className="form-control" id="Eame" placeholder="Enter your full name" value={Name} onChange={(e) => setName(e.target.value)} />
                    {errors.name && <div className="text-danger">{errors.name}</div>}
                </div>

                <div className="mb-3">
                    <label htmlFor="Email" className="form-label">Your Email</label>
                    <input type="email" className="form-control" id="Email" placeholder="Enter your email address" value={Email} onChange={(e) => setEmail(e.target.value)} />
                    {errors.email && <div className="text-danger">{errors.email}</div>}
                </div>

                <div className="mb-3">
                    <label htmlFor="Subject" className="form-label">Subject</label>
                    <input type="text" className="form-control" id="Subject" placeholder="Reason for contact" value={Subject} onChange={(e) => setSubject(e.target.value)} />
                    {errors.subject && <div className="text-danger">{errors.subject}</div>}
                </div>

                <div className="mb-3">
                    <label htmlFor="Message" className="form-label">Message</label>
                    <textarea className="form-control" id="Message" rows="5" placeholder="Write your message here..." value={Message} onChange={(e) => setMessage(e.target.value)}></textarea>
                    {errors.message && <div className="text-danger">{errors.message}</div>}
                </div>

                <button type="submit" className="btn btn-primary" disabled={loading}>

                    {!loading ? "Send Message" : (
                        <>
                            <span className="dot dot1 mx-2 text-center"></span>
                            <span className="dot dot2 mx-2"></span>
                            <span className="dot dot3 mx-2"></span>
                        </>
                    )}

                </button>
            </form>
        </div>
    );
};

export default ContactForm;
